import React from 'react';

import { usePage } from '@brz-utils/contexts/page.context';
import { FAQSchema } from './faq.schema';
import { HowToSchema } from './how-to.schema';
import { OrgSchema } from './org.schema';
import { BreadcrumbsSchema } from './breadcrumbs';



export const SEO = () => {
    const { page, template } = usePage();

    return <>
        {/* No Index if excluded from sitemap */}
        {page.sitemap?.exclude ? (
            <meta name="robots" content="noindex" />
        ) : null}

        {/* Schemas */}
        {page.seo?.org?.disable || template?.disable?.orgSchema ? null : <OrgSchema />}
        {page.seo?.faq?.disable || template?.disable?.faqSchema ? null : <FAQSchema />}
        {page.seo?.howTo?.disable || template?.disable?.howToSchema ? null : <HowToSchema />}
        {page.sitemap?.breadcrumbs?.length ? <BreadcrumbsSchema /> : null}
        
        
        
    </>
};

